var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3125 20.5873C43.115 12.4198 35.51 7.71729 27.5 7.71729C23.495 7.71729 19.6025 8.88729 16.0475 11.0698C12.4925 13.2748 9.2975 16.4923 6.6875 20.5873C4.4375 24.1198 4.4375 29.8573 6.6875 33.3898C11.885 41.5798 19.49 46.2598 27.5 46.2598C31.505 46.2598 35.3975 45.0898 38.9525 42.9073C42.5075 40.7023 45.7025 37.4848 48.3125 33.3898C50.5625 29.8798 50.5625 24.1198 48.3125 20.5873ZM27.5 36.0898C22.46 36.0898 18.41 32.0173 18.41 26.9998C18.41 21.9823 22.46 17.9098 27.5 17.9098C32.54 17.9098 36.59 21.9823 36.59 26.9998C36.59 32.0173 32.54 36.0898 27.5 36.0898Z",
    fill: "#DDE1EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5004 20.5649C23.9679 20.5649 21.0879 23.4449 21.0879 26.9999C21.0879 30.5324 23.9679 33.4124 27.5004 33.4124C31.0329 33.4124 33.9354 30.5324 33.9354 26.9999C33.9354 23.4674 31.0329 20.5649 27.5004 20.5649Z",
    fill: "#DDE1EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.72277742b4ed791dafbf526c867985bd.svg";
export { ForwardRef as ReactComponent };